// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=Poppins:wght@300;400;500;600;700&family=Lora:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  color-scheme: only light;
  -webkit-text-size-adjust: 100%;
  background-color: #ffffff;
}

:root {
  color-scheme: light only;
}

body {
  font-family: 'Poppins', sans-serif;
  color: #333;
  line-height: 1.8;
  letter-spacing: 0.3px;
  background-color: #ffffff;
}

#root,
.App {
  background-color: #ffffff;
  color: #333333;
}

/* Animación de scroll reveal */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.reveal {
  animation: slideInUp 0.8s ease-out;
}

.App {
  width: 100%;
  overflow-x: hidden;
}

/* Colores principales GW */
:root {
  --primary: #FF8C00;
  --secondary: #5B4B8A;
  --accent: #2c5f8d;
  --light-bg: #f8f9fa;
  --dark-bg: #1a1a1a;
  --text-dark: #2c3e50;
  --text-light: #ecf0f1;
}

@media (prefers-color-scheme: dark) {
  :root {
    color-scheme: light only;
    --primary: #FF8C00;
    --secondary: #5B4B8A;
    --accent: #2c5f8d;
    --light-bg: #f8f9fa;
    --dark-bg: #1a1a1a;
    --text-dark: #2c3e50;
    --text-light: #ecf0f1;
  }

  html,
  body,
  #root,
  .App {
    background-color: #ffffff;
    color: #333333;
  }
}

@media (forced-colors: active) {
  html,
  body {
    forced-color-adjust: none;
  }
}

/* Botones */
.btn {
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.btn-primary {
  background-color: var(--primary);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 140, 0, 0.3);
}

.btn-primary:hover {
  background-color: #e67e00;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(255, 140, 0, 0.4);
}

.btn-secondary {
  background-color: var(--secondary);
  color: white;
  box-shadow: 0 4px 15px rgba(91, 75, 138, 0.3);
}

.btn-secondary:hover {
  background-color: #493d6b;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(91, 75, 138, 0.4);
}

/* Contenedores */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 120px 0;
  position: relative;
}

.section-title {
  text-align: center;
  font-size: 3.5em;
  margin-bottom: 80px;
  color: #5B4B8A;
  position: relative;
  padding-bottom: 30px;
  font-family: 'Playfair Display', serif;
  font-weight: 800;
  letter-spacing: -1.5px;
  line-height: 1.2;
  word-spacing: 0.1em;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 5px;
  background: linear-gradient(90deg, var(--secondary), var(--primary));
  border-radius: 3px;
}

/* Grid */
.grid {
  display: grid;
  gap: 40px;
}

.grid-2 {
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.grid-3 {
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

/* Tarjetas */
.card {
  background: white;
  border-radius: 15px;
  padding: 40px 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 140, 0, 0.1), transparent);
  transition: left 0.6s ease;
  z-index: 0;
}

.card:hover {
  transform: translateY(-15px) scale(1.02);
  box-shadow: 0 25px 60px rgba(255, 140, 0, 0.2);
}

.card:hover::before {
  left: 100%;
}

.card-icon {
  font-size: 3.5em;
  margin-bottom: 20px;
}

.card h3 {
  color: var(--primary);
  margin-bottom: 15px;
  font-size: 1.6em;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
}

.card p {
  color: #666;
  line-height: 1.9;
  font-size: 0.95em;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Playfair Display', serif;
}

/* Responsive */
@media (max-width: 768px) {
  .section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 2.2em;
  }

  .grid-2,
  .grid-3 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;;;;IAIE,yBAAyB;IACzB,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;AACF;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,oEAAoE;EACpE,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,oDAAoD;EACpD,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oFAAoF;EACpF,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=Poppins:wght@300;400;500;600;700&family=Lora:wght@400;500;600&display=swap');\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml {\r\n  color-scheme: only light;\r\n  -webkit-text-size-adjust: 100%;\r\n  background-color: #ffffff;\r\n}\r\n\r\n:root {\r\n  color-scheme: light only;\r\n}\r\n\r\nbody {\r\n  font-family: 'Poppins', sans-serif;\r\n  color: #333;\r\n  line-height: 1.8;\r\n  letter-spacing: 0.3px;\r\n  background-color: #ffffff;\r\n}\r\n\r\n#root,\r\n.App {\r\n  background-color: #ffffff;\r\n  color: #333333;\r\n}\r\n\r\n/* Animación de scroll reveal */\r\n@keyframes slideInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(50px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slideInLeft {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-50px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes slideInRight {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(50px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.reveal {\r\n  animation: slideInUp 0.8s ease-out;\r\n}\r\n\r\n.App {\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* Colores principales GW */\r\n:root {\r\n  --primary: #FF8C00;\r\n  --secondary: #5B4B8A;\r\n  --accent: #2c5f8d;\r\n  --light-bg: #f8f9fa;\r\n  --dark-bg: #1a1a1a;\r\n  --text-dark: #2c3e50;\r\n  --text-light: #ecf0f1;\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\r\n  :root {\r\n    color-scheme: light only;\r\n    --primary: #FF8C00;\r\n    --secondary: #5B4B8A;\r\n    --accent: #2c5f8d;\r\n    --light-bg: #f8f9fa;\r\n    --dark-bg: #1a1a1a;\r\n    --text-dark: #2c3e50;\r\n    --text-light: #ecf0f1;\r\n  }\r\n\r\n  html,\r\n  body,\r\n  #root,\r\n  .App {\r\n    background-color: #ffffff;\r\n    color: #333333;\r\n  }\r\n}\r\n\r\n@media (forced-colors: active) {\r\n  html,\r\n  body {\r\n    forced-color-adjust: none;\r\n  }\r\n}\r\n\r\n/* Botones */\r\n.btn {\r\n  padding: 12px 30px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-family: 'Poppins', sans-serif;\r\n  font-weight: 600;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: var(--primary);\r\n  color: white;\r\n  box-shadow: 0 4px 15px rgba(255, 140, 0, 0.3);\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #e67e00;\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 8px 25px rgba(255, 140, 0, 0.4);\r\n}\r\n\r\n.btn-secondary {\r\n  background-color: var(--secondary);\r\n  color: white;\r\n  box-shadow: 0 4px 15px rgba(91, 75, 138, 0.3);\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background-color: #493d6b;\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 8px 25px rgba(91, 75, 138, 0.4);\r\n}\r\n\r\n/* Contenedores */\r\n.container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 0 20px;\r\n}\r\n\r\n.section {\r\n  padding: 120px 0;\r\n  position: relative;\r\n}\r\n\r\n.section-title {\r\n  text-align: center;\r\n  font-size: 3.5em;\r\n  margin-bottom: 80px;\r\n  color: #5B4B8A;\r\n  position: relative;\r\n  padding-bottom: 30px;\r\n  font-family: 'Playfair Display', serif;\r\n  font-weight: 800;\r\n  letter-spacing: -1.5px;\r\n  line-height: 1.2;\r\n  word-spacing: 0.1em;\r\n}\r\n\r\n.section-title::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 120px;\r\n  height: 5px;\r\n  background: linear-gradient(90deg, var(--secondary), var(--primary));\r\n  border-radius: 3px;\r\n}\r\n\r\n/* Grid */\r\n.grid {\r\n  display: grid;\r\n  gap: 40px;\r\n}\r\n\r\n.grid-2 {\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n}\r\n\r\n.grid-3 {\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n}\r\n\r\n/* Tarjetas */\r\n.card {\r\n  background: white;\r\n  border-radius: 15px;\r\n  padding: 40px 30px;\r\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\r\n  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);\r\n  text-align: center;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(255, 140, 0, 0.1), transparent);\r\n  transition: left 0.6s ease;\r\n  z-index: 0;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-15px) scale(1.02);\r\n  box-shadow: 0 25px 60px rgba(255, 140, 0, 0.2);\r\n}\r\n\r\n.card:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.card-icon {\r\n  font-size: 3.5em;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.card h3 {\r\n  color: var(--primary);\r\n  margin-bottom: 15px;\r\n  font-size: 1.6em;\r\n  font-family: 'Poppins', sans-serif;\r\n  font-weight: 700;\r\n}\r\n\r\n.card p {\r\n  color: #666;\r\n  line-height: 1.9;\r\n  font-size: 0.95em;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n  font-family: 'Playfair Display', serif;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .section {\r\n    padding: 60px 0;\r\n  }\r\n\r\n  .section-title {\r\n    font-size: 2.2em;\r\n  }\r\n\r\n  .grid-2,\r\n  .grid-3 {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
